module.exports = __webpack_public_path__ + "static/media/มะแม.21edb837.jpg";